import { useIsMobile } from '@/hooks/utilities/use-mobile';
import classNames from '@/lib/misc/classNames';
import Image from 'next/image';
import { FaArrowLeft } from 'react-icons/fa6';
import { IoIosArrowBack } from 'react-icons/io';
export default function QuoteError({
  swapLoading,
  setIsConfirmationDialogOpen,
  onClickBack
}) {
  const isMobile = useIsMobile();
  return <div className={classNames('mt-5 bg-genius-cream-foreground rounded-b-3xl', {
    invisible: swapLoading,
    visible: !swapLoading
  })} data-sentry-component="QuoteError" data-sentry-source-file="QuoteError.tsx">
      <div className='ta-c w-full m-auto max-w-[393px]'>
        {isMobile && <div className='w-full ta-l'>
            <div onClick={() => {
          if (onClickBack) {
            onClickBack();
          } else {
            setIsConfirmationDialogOpen(false);
          }
        }} className='w-fit text-genius-cream text-[14px] flex ml-4 items-center  justify-start bg-genius-blue rounded-full h-[31px] w-[74px] px-2'>
              <IoIosArrowBack className='w-[16px]' />
              Back
            </div>
          </div>}

        <div className='px-6'>
          <Image className='mt-[20%] m-auto' alt='error' src='/static/images/idea-error.png' width={68} height={68} data-sentry-element="Image" data-sentry-source-file="QuoteError.tsx" />
          <h1 className='font-normal text-[36px] text-genius-cream/50 mt-14'>Not Very Smart</h1>
          <p className='text-sm mt-10 text-genius-cream/50'>
            Failed to Generate a quote! This one is on us. Please try increasing your slippage below
            and refresh for new quotes.
          </p>
        </div>
      </div>
    </div>;
}